//
//
//
//
//
//
//
//
//
//
//
//
//

import DetailBlock from './DetailBlock';
export default {
  name: 'detail-light',
  components: {
    DetailBlock: DetailBlock
  },
  props: {
    brightName: String,
    brightPointList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isCategory: {
      type: Boolean
    }
  }
};